import { ArtistPortalConnectResult } from './useArtistPortalConnect';

/** What the connect sheet does after a sign-in answered. */
export enum ConnectOutcome {
  /** The server picked the one artist: nothing left to ask. */
  done = 'done',
  /** Several artists: the artist picks one. */
  pickArtist = 'pickArtist',
  /** The sign-in worked but holds no artist: say so, never close in silence. */
  noArtist = 'noArtist',
}

export function connectOutcome(result: Pick<ArtistPortalConnectResult, 'artists'>): ConnectOutcome {
  if (result.artists.length === 0) {
    return ConnectOutcome.noArtist;
  }
  return result.artists.length > 1 ? ConnectOutcome.pickArtist : ConnectOutcome.done;
}
